import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const Invalid = styled.span`
  border-radius: 4px;
  background-color: #e43538;
  font-size: var(--font-size-12);
  color: var(--color-milk);
  margin-right: 10px;
  width: auto;
  font-weight: 500;
  padding: 4px 10px;
`;

export const RCardExtended = styled.div<{ isPages?: boolean }>`
  padding: 24px;
  border-radius: 4px;
  /* background: var(--color-milk); */
  border: 1px solid var(--color-smoke-50);
  // box-shadow: var(--shadow-default);
  align-items: flex-start;
  margin-bottom: 14px;
  width: 100%;
  position: relative;
  flex-direction: column;
  background-color: ${({ isPages }) =>
    isPages ? '#f4f7f9' : 'var(--color-milk)'};
  .row {
    display: flex;
    justify-content: space-between;
    align-items: start;
    width: 100%;
    margin-bottom: 20px;

    &.left-align {
      justify-content: flex-start !important;
      margin-bottom: 14px;
      align-items: center;
    }
  }
  .user-info {
    display: flex;
    align-items: center;
    .name {
      margin-bottom: 0;
      font-size: 20px;
      font-weight: 700;
      max-width: 400px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 30px;
      color: var(--text-link);
      cursor: pointer;
    }
    .Deletedcontact {
      cursor: default;
    }
    .Anonymoususer {
      cursor: default;
    }
  }

  .time-rating {
    display: flex;
    align-items: center;
    gap: 12px;
    .sentiment-button {
      padding: 6px 10px;
      border-radius: 4px;
      background-color: #ffffff;
      background: linear-gradient(to bottom, #fff, #fff) padding-box,
        linear-gradient(60deg, #ffce22, #0085ff, #8a80ff) border-box;
      border: 2px solid transparent;
    }

    div {
      &:last-child {
        cursor: pointer;
      }
    }
  }
  .translation {
    font-size: 14px;
    padding-right: 10px;
    border-right: 1px solid #c1d0da;
    .translation-to-other-language {
      color: #2c5cc5;
      display: flex;
      align-items: center;
      gap: 4px;
      background: none;
      border: none;
      outline: none;
      box-shadow: none;
      padding: 0;
      font-weight: 400;
    }
    .translation-to-other-language:hover {
      background: none;
    }
    .translate-language {
      background: #f2f2f2;
      padding: 10px;
      cursor: default;
      height: 28px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .show-original-container {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .show-original {
      background: none;
      border: none;
      outline: none;
      box-shadow: none;
      color: #2c5cc5;
      padding: 0;
      font-weight: 400;
    }
    .show-original:hover {
      background: none;
    }
  }
  .timestamp {
    font-weight: 500;
    font-size: 12px;
    line-height: 30px;
    color: var(--secondary-color);
    white-space: nowrap;
  }
  .pages-card {
    background: var(--color-milk);
    margin: 16px 0px;
    border-radius: 8px;
    padding: 16px 16px 1px 16px;
    .page-name-desc-container {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 16px;
      .page-name {
        font-weight: 600;
        padding: 6px 8px;
        border-radius: 4px;
        display: flex;
        width: fit-content;
        white-space: nowrap;
        line-height: 1;
        font-size: 12px;
        background-color: #e5f2fd;
        color: #2c5cc5;
      }
    }
  }

  .created-date {
    color: var(--secondary-color);
    font-size: 10px;
    font-style: italic;
    line-height: 30px;
    position: absolute;
    top: 100%;
    z-index: 1;
    text-align: center;
    width: 100%;
  }

  .response-loader {
    margin-top: 0;
    margin-bottom: 10px;
    width: 100%;
  }

  .channel {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: var(--secondary-color);
  }

  .action-info {
    margin-left: 54px;
    .channel {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: var(--secondary-color);
    }
  }

  .card-footer-readonly {
    padding-top: 0 !important;
    border-top: none !important;
  }
  .card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
    /* border-top: ${({ isPages }) =>
      isPages ? '' : '1px solid var(--border-color)'}; */
    .tag-google-container {
      display: flex;
      gap: 10px;
      .translate-container {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: gray;
        cursor: pointer;
        filter: grayscale(1);
        :hover {
          filter: grayscale(0);
        }
      }
      .google-logo {
        bottom: 1px;
        margin-left: 3px;
      }
    }
    .score-weight-wrap {
      display: flex;
      align-items: center;
      gap: 5px;
      label {
        color: #666;
        font-size: 14px;
        font-weight: 400;
        text-wrap: nowrap;
      }
      .score {
        font-size: 14px;
        font-weight: 500;
        color: var(--color-smoke-700);
      }
      .sentiment {
        font-size: 12px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 4px;
        color: var(--color-smoke-700);
        border: 1px solid var(--color-smoke-100);
        background: var(--color-smoke-50);
      }
      &.positive {
        .score {
          color: #058538;
        }
        .sentiment {
          color: #058538;
          border-color: #a7d8bb;
          background: #deeee4;
        }
      }
      &.neutral {
        .score {
          color: #db9815;
        }
        .sentiment {
          color: #db9815;
          border-color: #f2d9b3;
          background: #fff1dd;
        }
      }
      &.negative {
        .score {
          color: #c82124;
        }
        .sentiment {
          color: #c82124;
          border-color: #facecf;
          background: #faeaea;
        }
      }
    }
  }
`;
export const StyledQuestionTitle = styled.span<{
  theme: string;
  isDeleted: boolean;
  deletedText: string;
}>`
  strong {
    font-weight: 600;
  }
  a {
    color: #2c5cc5;
    cursor: pointer;
    text-decoration: underline;
  }
  p {
    margin: 0;
  }
  ul {
    padding: 0px 20px;
    strong {
      font-weight: 600;
    }
  }
  &:has(p) {
    p:last-child:after {
      ${ChipStyleMixin}
      content: ${({ theme, isDeleted, deletedText }) =>
        theme.length ? `'${theme}'` : isDeleted ? `'${deletedText}'` : ''};
      font-weight: 600;
      margin-left: 4px;
      color: #384551;
      background: var(--color-smoke-50);
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  &:not(:has(p)) {
    &::after {
      ${ChipStyleMixin}
      content: ${({ theme, isDeleted, deletedText }) =>
        theme.length ? `'${theme}'` : isDeleted ? `'${deletedText}'` : ''};
      font-weight: 600;
      color: #384551;
      background: var(--color-smoke-50);
      border-radius: 4px;
      margin-right: 10px;
    }
  }
`;

export const ResponseCardContent = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
  flex: 1;
  overflow: auto;
  &.invalid-content {
    opacity: 0.4;
  }

  .overall-score {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 24px;
    label {
      color: #666;
      font-size: 14px;
      font-weight: 400;
      margin-right: 5px;
    }
  }

  .question {
    flex: 1;
    margin-bottom: 24px;
    word-wrap: break-word;
    margin-top: 5px;
    overflow: auto;
  }

  .question-wrap {
    display: flex;
    justify-content: space-between;
  }
  .response-question-card {
    max-width: 100%;
    display: flex;
    align-items: baseline;
    .question-number {
      flex: 0;
      align-items: flex-start;
      color: var(--secondary-color);
      font-size: 14px;
      margin-top: 5px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    margin-bottom: 0;
    line-height: 1.5;
    color: var(--secondary-color);
    width: 100%;
    .quesion-title-wrapper {
      display: flex;
      gap: 2px;
      width: 100%;
      span:first-child {
        width: 70%;
      }
    }
  }

  .theme-label {
    ${ChipStyleMixin}
    font-weight: 600;
    color: #384551;
    background: var(--color-smoke-50);
    border-radius: 4px;
    display: inline;
  }

  .score-chip {
    ${ChipStyleMixin}
    max-height: 25px;
    display: inline-flex;
    align-items: center;
    border-radius: 4px;
    background: var(--color-smoke-50);
    font-weight: 600;
    .given-score {
      color: #384551;
    }
    .max-score {
      color: #979797;
      &:before {
        content: '/';
        margin: 0 2px;
      }
    }
  }

  .description {
    font-size: 14px;
    color: var(--base-color);
    font-weight: 600;
    line-height: 24px;
    margin-top: 5px;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  .form-field {
    font-size: 14px;
    text-align: left;
    .label {
      line-height: 26px;
      color: var(--base-color);
      vertical-align: baseline;
    }
  }

  .actions {
    border-top: 1px solid var(--color-smoke-50);
    padding: 15px 0;
    white-space: nowrap;
    button {
      margin: 0 5px 0 0;
    }
  }

  div.more {
    color: #264966;
    cursor: pointer;
    font-size: 12px;
    margin-bottom: 8px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeff3;
  }

  div.view-all {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 400;
    font-size: 12px;
    line-height: 30px;
    color: #006cc2;
    width: fit-content;
    cursor: pointer;
  }
`;

const BoxColor: any = {
  primary: {
    textColor: '#12344d',
    bgColor: '#ffecf0',
    border: '#FFD0D6',
  },
  default: {
    textColor: '#12344d',
    bgColor: '#FBF0DE',
    border: '#FDDBB5',
  },
  info: {
    textColor: '#12344d',
    bgColor: '#E5F2FD',
    border: '#BBDCFE',
  },
};

type NotePropsType = {
  type: string;
};

export const StyledNote = styled.div<NotePropsType>`
  padding: 12px;
  background: ${({ type }) => (type ? BoxColor[type]?.bgColor : '#fff')};
  border: 1px solid ${({ type }) => (type ? BoxColor[type]?.border : '#fff')};
  border-radius: 8px;
  color: ${({ type }) => (type ? BoxColor[type]?.textColor : '#fff')};
  align-items: center;
  margin-bottom: 12px;
  max-width: 575px;
  width: 90%;
  position: relative;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;

  .label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
  }

  .message {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 5px;
    word-break: break-word;
    ${({ type }) =>
      type === 'primary' &&
      `
    padding-top: 5px;`};

    span {
      cursor: pointer;
      text-decoration: underline;
      color: var(--text-link);
      &.no-underline {
        text-decoration: none !important;
        color: var(--base-color);
      }
    }
  }
  .created-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: ${({ type }) => (type ? BoxColor[type]?.textColor : '#12344d')};
  }

  .note-actions {
    position: absolute;
    right: 10px;
    top: 10px;
    background: #ffffff;
    border: 0.5px solid #f6d8b0;
    box-shadow: 0px 2px 4px rgba(18, 52, 77, 0.06);
    border-radius: 4px;
    display: flex;
    visibility: hidden;
    align-items: center;
    > div {
      padding: 2px 6px 0px 6px;
      cursor: pointer;
      &:first-child {
        border-right: 0.5px solid #f6d8b0;
      }
    }
  }

  &:hover {
    .note-actions {
      visibility: visible;
    }
  }

  .note-type-icon {
    margin-right: 6px;
  }

  .note-body {
    width: 100%;
  }
`;

export const NotesContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export const Tag = styled.span<any>`
  ${ChipStyleMixin}
  border-radius: 4px;
  background-color: #ffffff;
  border: 1px solid #cfd7df;
  font-size: var(--font-size-12);
  color: var(--base-color);
  margin: 2px;
  display: inline-block;
  width: auto;
  font-weight: 500;
  word-break: break-all;
  white-space: nowrap;
  ${(props: any) =>
    props.isLabel &&
    `
    background: #F1F4F6 !important;
    border: 1px solid #F2F2F2 !important;
    padding: 8px 10px !important;
    font-style: italic; 
    font-size: 10px !important;
    line-height: 9px;
    font-weight: 400 !important;
`};
`;

export const StyledInvalidMessage = styled.div`
  width: 500px;
  padding: 4px;
  .input-basic textarea:focus ~ .end-max-length {
    opacity: 1 !important;
  }
`;

export const StyledRankOrderItem = styled.div<RankOrderProps>`
  --default-brand-color: ${({ brandColor }) => brandColor || '#E50914'};
  --default-text-color: ${({ textColor }) => textColor || '#fff'};
  display: flex;
  align-items: center;
  margin-top: 10px;
  .rank-content-container {
    color: var(--default-brand-color);
    font-weight: 500;
    max-width: 90%;
    display: flex;
    align-items: center;
    background-color: #fff4f5;
    padding: 12px 15px;
    gap: 10px;
    border-radius: 4px;
    .item-rank {
      width: 20px;
      height: 20px;
      font-size: 12px;
      justify-content: center;
      background-color: var(--default-brand-color);
      color: var(--default-text-color);
      border-radius: 50%;
      text-align: center;
      display: flex;
      align-items: center;
    }
    .item-content {
      max-width: 95%;
      min-width: 250px;
      font-size: 14px;
      border-radius: 4px;
    }
  }
`;

export const StyledFileQn = styled.div<{ isDownloading: boolean }>`
  .file-qn {
    a {
      display: flex;
      column-gap: 10px;
      align-items: center;
      color: var(--text-link);
      text-decoration: underline;
    }
    a {
      ${(props) => props.isDownloading && 'cursor: not-allowed; !important'}
    }
  }
`;

type RankOrderProps = {
  brandColor: string;
  textColor: string;
};
